export const customEvent = {
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    emit(eventType, data) {
        const event = new CustomEvent(eventType, {
            detail: data,
            bubbles: true,
            cancelable: false,
        });
        document.dispatchEvent(event);
    },
    listen(eventType, listener) {
        document.addEventListener(eventType, listener);
    },
    removeListener(eventType, listener) {
        document.removeEventListener(eventType, listener);
    },
};
//# sourceMappingURL=customEvent.js.map